/* @jsx jsx */
import { css, jsx } from '@emotion/react';
import {
  Menu,
  MenuItem,
  sizes,
  Spacer,
  TypeRampV2,
} from '@smartsheet/lodestar-core';
import { CloseIcon, KebabIcon } from '@smartsheet/lodestar-icons';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  GraphNodeTypes,
  selectedElementSelector,
} from '../../../../../services/ducks/designerDuck/designerDuck';
import { selectModuleById } from '../../../../../services/ducks/modulesDuck/modulesDuck';
import { Column } from '../../../../common/Column';
import { VerticalBar } from '../../../../common/Panel/styled';
import { PanelButton } from '../../../../common/Panel/styled/PanelButton';
import { GraphNodeTypeLabels } from '../../../Canvas/utils';

export const PanelHeader = ({
  options,
  onClose,
  selectedElement,
}: {
  options?: ReturnType<typeof MenuItem>[];
  onClose: { (): void };
  selectedElement: ReturnType<typeof selectedElementSelector>;
}) => {
  const { t: translate } = useTranslation();
  const [isOptionsMenuOpen, setIsOptionsMenuOpen] = useState(false);
  const ref = useRef(null);
  const selectedModule = useSelector(
    selectModuleById(selectedElement.moduleID, selectedElement.pluginUUID)
  );

  if (!selectedElement) return null;

  const panelItemsSpacingStyle = css`
    justify-content: space-between;
    padding-bottom: ${sizes.large}px;
  `;

  const panelTitleStyle = css`
    && {
      font-size: 20px;
      line-height: 24px;
    }
  `;

  return (
    <div data-pa11y-id="edit-module-panel-header">
      <Spacer orientation="row" space="small" css={panelItemsSpacingStyle}>
        <Column>
          <TypeRampV2
            system="lodestar"
            variant="headlineMedium"
            css={panelTitleStyle}
          >
            {translate(
              GraphNodeTypeLabels[selectedElement.type as GraphNodeTypes],
              { ns: 'common' }
            )}
          </TypeRampV2>
        </Column>
        <Column
          css={css`
            justify-content: flex-end;
          `}
        >
          {options ? (
            <React.Fragment>
              <PanelButton
                ref={ref}
                active={isOptionsMenuOpen}
                onClick={() => setIsOptionsMenuOpen(true)}
              >
                <KebabIcon />
              </PanelButton>
              <Menu
                aria-label={translate('common:options')}
                placement="bottom-end"
                targetElement={ref}
                isOpen={isOptionsMenuOpen}
                onCloseRequested={() => setIsOptionsMenuOpen(false)}
                id="xx"
              >
                {options}
              </Menu>
              <VerticalBar />
            </React.Fragment>
          ) : null}
          <PanelButton onClick={onClose}>
            <CloseIcon />
          </PanelButton>
        </Column>
      </Spacer>
      <div>
        <TypeRampV2 system="lodestar" variant="bodyText">
          {selectedModule.description}
        </TypeRampV2>
      </div>
    </div>
  );
};
